if (!customElements.get('sm-metafields')) customElements.define('sm-metafields', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.addEventListener('click', event => {
      const open = event.target.closest('[data-sm-meta-open]');
      if (open) {
        const dialog = [...this.querySelectorAll('[data-sm-meta-dialog]')].find(item => item.dataset.smMetaDialog === open.dataset.smMetaOpen);
        if (dialog && !dialog.open) { this.trigger = open; dialog.showModal(); }
      }
      if (event.target.closest('[data-sm-meta-close]')) event.target.closest('dialog')?.close();
      if (event.target.tagName === 'DIALOG') {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      }
    }, {signal: this.controller.signal});
    this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => this.trigger?.focus(), {signal: this.controller.signal}));
  }
  disconnectedCallback() {
    this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    this.controller?.abort(); this.controller = null;
  }
});
if (!customElements.get('sm-legacy-frames')) customElements.define('sm-legacy-frames', class extends HTMLElement {
  connectedCallback() {
    if (this.frameController) return;
    this.productInfo = this.closest('product-info');
    this.mapping = JSON.parse(this.querySelector('[data-sm-frames-variants]')?.textContent || '{}');
    this.bind(this.querySelector('[data-sm-initial-variant]')?.dataset.smInitialVariant);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (String(event.data.sectionId) === this.dataset.productSection) this.bind(event.data.variant?.id);
    });
  }
  bind(variantId) {
    this.frameController?.abort(); this.restore?.(); this.frameController = new AbortController();
    const signal = this.frameController.signal;
    const marker = this.mapping[String(variantId)];
    if (typeof marker !== 'string' || !marker.trim()) return;
    const image = [...(this.productInfo?.querySelectorAll('media-gallery img') || [])].find(img => img.alt.replace('#color_', '') === marker || (!/\s/.test(marker) && img.closest('[class]')?.classList.contains(marker)));
    if (!image) return;
    let base; try { base = new URL(this.dataset.base, location.origin); } catch { return; }
    if (base.protocol !== 'https:' || !/^\d+$/.test(String(variantId))) return;
    const originalSrc = image.getAttribute('src'), originalSrcset = image.getAttribute('srcset');
    this.restore = () => { if (originalSrc) image.setAttribute('src', originalSrc); if (originalSrcset) image.setAttribute('srcset', originalSrcset); };
    const count = Math.max(2, Math.min(36, Number(this.dataset.count) || 8));
    let current = -1, pending = 0;
    const host = image.closest('li') || image;
    host.addEventListener('pointermove', event => {
      const rect = host.getBoundingClientRect(); if (!rect.width) return;
      const frame = Math.min(count, Math.max(1, Math.floor((event.clientX - rect.left) / rect.width * count) + 1));
      if (frame === current) return; current = frame;
      const sequence = ++pending, preload = new Image();
      preload.onload = () => { if (sequence === pending && this.isConnected && !signal.aborted) { image.removeAttribute('srcset'); image.src = preload.src; } };
      preload.src = `${base.href.replace(/\/$/, '')}/${variantId}_${frame}.png`;
    }, {signal});
    host.addEventListener('pointerleave', () => { pending++; current = -1; this.restore(); }, {signal});
  }
  disconnectedCallback() { this.frameController?.abort(); this.restore?.(); this.unsubscribe?.(); this.frameController = null; }
});
